import { createRoot } from 'react-dom/client';
import './styles/fonts';
import './styles/colors_and_type.css';
import './styles/base.css';
import { App } from './App';
import { loadRuntimeConfig } from './config/runtime';
import { configureRimoPreview } from '@rimocore/shared/preview/RimoPreview';
import './components/ctx/setup';
import { isFr } from './i18n/lang';
import { printBytes, saveBytes } from './desktop/files';
import { bootUpdater } from './desktop/updater';

// RimoPreview (suite module, RimoCore/shared/preview/README.md): language, and how this program saves (desktop: save
// dialog) and prints (hidden frame in the app).
configureRimoPreview({ icon: '/assets/rimopreview.svg', lang: () => (isFr() ? 'fr' : 'de'), save: (b, name, mime) => saveBytes(b, name, { mime }), print: (b, mime) => printBytes(b, mime) });

// RimoID address from the API first (web), then the app.
bootUpdater();
void loadRuntimeConfig().finally(() => createRoot(document.getElementById('dc-root')!).render(<App />));
